/*
 * Global Messages
 *
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.title',
    defaultMessage: '{companyName} Fotógrafos',
  },
});
